(() => {
  const pushEvent = (event, parameters = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...parameters });
  };

  const initFaq = (root) => {
    if (root.dataset.chatbotReady === 'true') return;
    root.dataset.chatbotReady = 'true';

    const launcher = root.querySelector('[data-chatbot-launcher]');
    const panel = root.querySelector('[data-chatbot-panel]');
    const closeButton = root.querySelector('[data-chatbot-close]');
    const lineButton = root.querySelector('[data-chatbot-line-direct]');
    const faqScroll = root.querySelector('.shizen-chatbot__faq-scroll');
    const faqGroups = Array.from(root.querySelectorAll('.shizen-chatbot__faq-group'));
    const faqItems = Array.from(root.querySelectorAll('.shizen-chatbot__faq-item'));
    const firstGroupSummary = panel.querySelector('.shizen-chatbot__faq-group-summary');

    if (!launcher || !panel || !closeButton || !lineButton) return;

    const lineUrl = (root.dataset.lineUrl || 'https://lin.ee/ooWHGK4').trim();
    const updateFocusState = () => {
      const openGroup = faqGroups.find((group) => group.open);

      faqScroll?.classList.toggle('is-focus-mode', Boolean(openGroup));
      faqGroups.forEach((group) => {
        const openItem = Array.from(group.querySelectorAll('.shizen-chatbot__faq-item')).find((item) => item.open);

        group.classList.toggle('is-focus-group', group === openGroup);
        group.classList.toggle('has-focused-item', Boolean(openItem));
        group.querySelectorAll('.shizen-chatbot__faq-item').forEach((item) => {
          item.classList.toggle('is-focus-item', item === openItem);
        });
      });
    };

    const openPanel = () => {
      panel.hidden = false;
      root.classList.add('is-panel-open');
      launcher.setAttribute('aria-expanded', 'true');
      launcher.classList.add('is-panel-open');
      launcher.hidden = true;
      firstGroupSummary?.focus();
      pushEvent('shizen_faq_opened', {
        page_type: root.dataset.pageType || '',
      });
    };

    const closePanel = () => {
      panel.hidden = true;
      root.classList.remove('is-panel-open');
      launcher.hidden = false;
      launcher.setAttribute('aria-expanded', 'false');
      launcher.classList.remove('is-panel-open');
      launcher.focus();
    };

    pushEvent('shizen_faq_launcher_shown');

    launcher.addEventListener('click', () => {
      if (panel.hidden) {
        openPanel();
      } else {
        closePanel();
      }
    });

    closeButton.addEventListener('click', closePanel);

    lineButton.addEventListener('click', () => {
      pushEvent('shizen_faq_line_handoff', {
        page_type: root.dataset.pageType || '',
      });
      window.open(lineUrl, '_blank', 'noopener,noreferrer');
    });

    faqGroups.forEach((group) => {
      group.addEventListener('toggle', () => {
        if (!group.open) {
          group.querySelectorAll('.shizen-chatbot__faq-item').forEach((item) => {
            item.open = false;
          });
          updateFocusState();
          return;
        }

        faqGroups.forEach((otherGroup) => {
          if (otherGroup !== group) otherGroup.open = false;
        });
        updateFocusState();

        pushEvent('shizen_faq_group_opened', {
          group: group.querySelector('.shizen-chatbot__faq-group-summary')?.textContent?.trim().slice(0, 100) || '',
        });
      });
    });

    faqItems.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) {
          updateFocusState();
          return;
        }

        faqItems.forEach((otherItem) => {
          if (otherItem !== item) otherItem.open = false;
        });
        updateFocusState();

        pushEvent('shizen_faq_answer_opened', {
          question: item.querySelector('summary')?.textContent?.trim().slice(0, 100) || '',
        });
      });
    });
    updateFocusState();

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) closePanel();
    });

    const updateBottomOffset = () => {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      root.style.setProperty(
        '--shizen-chat-bottom',
        isMobile && root.dataset.pageType === 'product'
          ? 'calc(1.2rem + env(safe-area-inset-bottom))'
          : 'calc(0.6rem + env(safe-area-inset-bottom))'
      );
    };

    window.addEventListener('resize', updateBottomOffset, { passive: true });
    updateBottomOffset();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-chatbot-root]').forEach(initFaq);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) initAll(event.target);
  });
})();
